<template>
  <Banner>
    <Overlay slot="overlay" :opacity="0.5"></Overlay>

    <template slot="header" v-if="map.name">
      <h1>{{ $route.meta.name || map.name }}</h1>
    </template>

    <!-- ** ** -->

    <template slot="caption">
      <Loader
        :url="urlMap"
        :model="Model"
        v-model="map"
        @ready="onReady"
      >
        <span
          slot="result"
          v-if="map.info"
        >
          {{ map.info.description }}
        </span>
      </Loader>
    </template>

    <!-- ** ** -->

    <template v-if="map.name">
      <template slot="tabs">
        <!-- <Tab to="/overview" :disabled="true" v-tooltip="'Coming soon!'">Overview</Tab> -->
        <Tab to="/leaderboard">Leaderboard</Tab>

        <Tab
          to="/clans"
          v-if="$router.resolve ({ name: `${$route.name} Clans` }).href !== '/'"
        >Clans</Tab>

        <Tab to="/games">Games</Tab>
        <Tab to="/statistics">Statistics</Tab>

        <div
          class="Banner-controls"
          v-if="map.info.urls"
        >
          <a
            :href="map.info.urls.discord"
            target="_blank"
            class="Button"
            v-if="map.info.urls.discord"
            v-tooltip="'Discord'"
          ><i class="fab fa-discord" @click=""></i></a>

          <a
            :href="map.info.urls.download"
            target="_blank"
            class="Button"
            v-if="map.info.urls.download"
            v-tooltip="'Latest Map Version'"
          ><i class="fas fa-download"></i></a>

          <a
            :href="map.info.urls.website"
            target="_blank"
            class="Button"
            v-if="map.info.urls.website"
            v-tooltip="'Community Website'"
          ><i class="fas fa-globe"></i></a>
        </div>
      </template>

      <!-- ** ** -->

      <template
        slot="controls"
        v-if="
          isTab ('leaderboard') ||
          isTab ('statistics') ||
          isTab ('games')
        "
      >
        <Picker
          v-model="selected"
          :tree="tree"
          :save="map.name"
        >
        </Picker>
      </template>

      <template
        slot="content"
        v-if="selected.mode"
      >
        <component is="style">
          .PageGutter {
            background-image: url('{{ map.info.image }}');
          }
        </component>

        <Leaderboard
          v-if="
            isTab ('leaderboard')
          "
          :key="`leaderboard-${JSON.stringify (selected)}`"
          :pk="selected"
        ></Leaderboard>

        <Statistics
          v-if="
            isTab ('statistics')
          "
          :id="map.getStatsId (selected)"
          :key="`stats-${JSON.stringify (selected)}`"
        ></Statistics>

        <GameDirectory
          v-if="
            isTab ('games')
          "
          :key="`games-${JSON.stringify (selected)}`"
          :pk="selected"
        ></GameDirectory>
      </template>
    </template>
  </Banner>
</template>

<script>
  import config        from '@/config';
  import Banner        from '@/legacy/components/layout/Banner';
  import Tab           from '@/legacy/components/widgets/Tab';
  import Loader        from '@/legacy/components/widgets/Loader';
  import Overlay       from '@/legacy/components/widgets/Overlay';
  import Picker        from '@/legacy/components/widgets/Picker';
  import GameDirectory from '@/legacy/components/GameDirectory';
  import Statistics    from '@/legacy/components/Statistics';
  import Leaderboard   from '@/legacy/views/map/Leaderboard';
  import PickerTree    from '@/legacy/lib//model/PickerTree';
  import Model         from '@/legacy/lib//model/Map';
  import Menu          from '@/legacy/lib//model/Menu';
  import Key           from '@/legacy/lib//model/Key';

  import { isTab, metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      if (!this.map.name) {
        return;
      }

      return metaFactory ({
        title: this.map.name,
        description: this.map.info.description,
        noindex: true
      });
    },

    components: {
      Banner,
      Tab,
      Leaderboard,
      GameDirectory,
      Statistics,
      Loader,
      Overlay,
      Picker
    },

    data () {
      return {
        map      : {},
        tree     : null,
        selected : new Key ()
      }
    },

    beforeRouteLeave (to, from, next) {
      this.map      = {};
      this.tree     = null;
      this.selected = new Key ();

      next ();
    },

    computed: {
      urlMap () {
        return `/maps/${this.$route.name}`
      }
    },

    methods: {
      isTab,
      Model,

      onReady () {
        this.tree = new PickerTree ();

        let variants = this.map.variants;
        variants.sort ((a, b) => b.id - a.id);

        for (
          let variant of variants
        ) {
          for (
            let stats of variant.stats
          ) {
            this.tree.add (stats.key);
          }
        }

        this.tree.setDefaults ({
          round : 'Global',
          mode  : 'Global'
        });
      }
    }
  }
</script>
